import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'check-in-corporateheader',
  templateUrl: './corporateheader.component.html',
  styleUrls: ['./corporateheader.component.scss']
})
export class CorporateheaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
